export default __webpack_public_path__ + "static/media/CustomLogoutIcon.2af63252.png";